module.exports = __webpack_public_path__ + "static/media/eva_alert-triangle-primary.9d1803d8.svg";